module.exports = __webpack_public_path__ + "img/job_offer.21109599.svg";